import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/authContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const isPublicPath = pathname.startsWith("/brainstorming/canvas/preview/");

  if (!user && !isPublicPath) {
    return <Navigate to="/login" replace />;
  }

  return children;
};